import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiGetTransactionEvidenceEmailsRequest,
  DefaultApiPutTransactionEvidenceEmailsMoveToTrashRequest,
  DefaultApiPutTransactionEvidenceEmailsLinkToTransactionRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const getTransactionEvidenceEmails = async (
  instance: AxiosInstance,
  params: DefaultApiGetTransactionEvidenceEmailsRequest
) => {
  return await userApiDefaultApiFactory(instance).getTransactionEvidenceEmails(
    params
  )
}

export const putTransactionEvidenceEmailsMoveToTrash = async (
  instance: AxiosInstance,
  params: DefaultApiPutTransactionEvidenceEmailsMoveToTrashRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).putTransactionEvidenceEmailsMoveToTrash(params)
}

export const putTransactionEvidenceEmailsLinkToTransaction = async (
  instance: AxiosInstance,
  params: DefaultApiPutTransactionEvidenceEmailsLinkToTransactionRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).putTransactionEvidenceEmailsLinkToTransaction(params)
}

// Do Not Remove this line ===@import api client===
